import { createFileRoute } from '@tanstack/react-router'
import { ComplianceControlsPage } from '../../../components/ComplianceControlsPage'

export const Route = createFileRoute('/$org/compliance-controls/')({
  component: ComplianceControls,
  validateSearch: (search: Record<string, unknown>) => ({
    domain_code: (search.domain_code as string) || undefined,
  }),
})

function ComplianceControls() {
  return <ComplianceControlsPage />
}
